import { openModalError } from "components/modal-error";
import { AttendanceChatProps } from "../chats-context/types";
import { openModalConfirm } from "components/modal-confirm-new";
import { Text } from "@chakra-ui/react";
import { updateAtendimento } from "components/atendimentos-components/pagina-atendimento/pagined-form/parts/utils";
import { CheckIcon, CloseIcon } from "@chakra-ui/icons";
import { User } from "contexts/types/application-context-types";
import {
  AttendanceActionsTypes,
  FormControl,
} from "contexts/attendance-context/actions-reducer";

const changeSelectedAttendance = (
  dispatch: React.Dispatch<AttendanceActionsTypes>,
  setSelectedAttendance: React.Dispatch<
    React.SetStateAction<AttendanceChatProps | undefined>
  >,
  props: AttendanceChatProps
) => {
  dispatch({ type: "closeAttendance" });
  setSelectedAttendance({ ...props, unreadMessage: false });
};

export function onClickAttendanceChatCard({
  props,
  selectedAttendance,
  user,
  formControl,
  dispatch,
  setSelectedAttendance,
}: {
  props: AttendanceChatProps;
  selectedAttendance: AttendanceChatProps | undefined;
  user: User;
  formControl: FormControl;
  dispatch: React.Dispatch<AttendanceActionsTypes>;
  setSelectedAttendance: React.Dispatch<
    React.SetStateAction<AttendanceChatProps | undefined>
  >;
}) {
  const customerId = props.customerId;
  const etapa = props.etapa;
  const customerName = props.customerName;

  if (user.userData?.customerId != customerId && etapa === "PENDENTE") {
    openModalError({
      message:
        "Sem permissão para acessar o atendimento PENDENTE de " + customerName,
    });
    return;
  }
  if (props.id !== selectedAttendance?.id) {
    if (formControl.pendingChanges) {
      openModalConfirm({
        message: (
          <Text>
            Há alterações pendentes,{" "}
            <Text as="span" fontWeight="semibold">
              deseja salvar antes de mudar de atendimento?
            </Text>
          </Text>
        ),
        variant: "normal",
        confirmButtonStyle: { children: "Salvar" },
        rejectButtonStyle: { children: "Descartar" },
        onConfirm: async () => {
          try {
            await updateAtendimento({ formControl, dispatch });
            changeSelectedAttendance(dispatch, setSelectedAttendance, props);
          } catch (e) {}
        },
        onReject: () =>
          changeSelectedAttendance(dispatch, setSelectedAttendance, props),
      });
    } else {
      if (etapa === "PENDENTE") {
        openModalConfirm({
          message: "Deseja iniciar o atendimento?",
          onConfirm: () => {
            changeSelectedAttendance(dispatch, setSelectedAttendance, props);
          },
          confirmButtonStyle: {
            variant: undefined,
            leftIcon: <CheckIcon />,
          },
          rejectButtonStyle: {
            leftIcon: <CloseIcon w="12px" h="12px" />,
          },
        });
      } else {
        changeSelectedAttendance(dispatch, setSelectedAttendance, props);
      }
    }
  }
}
